<div class="page-container">
  <div class="page-header">
    <div class="page-title-section">
      <mat-icon>apartment</mat-icon>
      <div class="page-title">Appraiser offices</div>
    </div>
    <button mat-stroked-button color="primary" (click)="onAdd()" aria-label="Add appraiser office">
      <mat-icon>add</mat-icon> ADD OFFICE
    </button>
  </div>

  <div class="mat-elevation-z2 table-card">
    <table mat-table [dataSource]="dataSource" aria-label="Appraiser offices list">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Office name</th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>

      <ng-container matColumnDef="county">
        <th mat-header-cell *matHeaderCellDef>County</th>
        <td mat-cell *matCellDef="let row">{{ row.county }}</td>
      </ng-container>

      <ng-container matColumnDef="officeNumber">
        <th mat-header-cell *matHeaderCellDef>Office number</th>
        <td mat-cell *matCellDef="let row">{{ row.officeNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef>Active</th>
        <td mat-cell *matCellDef="let row">{{ row.active ? 'Yes' : 'No' }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="actions-cell">Action</th>
        <td mat-cell *matCellDef="let row" class="actions-cell">
          <button mat-icon-button (click)="onEdit(row); $event.stopPropagation()" [attr.aria-label]="'Edit ' + row.name">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button (click)="onDelete(row); $event.stopPropagation()" [attr.aria-label]="'Delete ' + row.name">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">No appraiser offices found.</td>
      </tr>
    </table>
  </div>

  <div class="footer-actions">
    <button mat-stroked-button (click)="goBack()" aria-label="Go back">GO BACK</button>
  </div>
</div>
